// extracted by mini-css-extract-plugin
module.exports = {"buttonLanguage":"LanguageSwitch_buttonLanguage__yq_Jm"};